import { z } from "zod";
import type { $ZodIssue } from "zod/v4/core";

export * from "zod"; // re-exporting zod types for convenience
export const event = z.object; // alias for readability and future extension.
export const oneOf = z.enum; // alias for readability and future extension.
export type ZodIssue = $ZodIssue;
